import React, { SetStateAction } from 'react'
import { CloseIcon } from 'utils/custom-icons'
import { classNames } from 'utils/dom-helpers'
export interface ISearchbox {
    value?: string
    setValue?: React.Dispatch<SetStateAction<string>>
    onClick?: () => any
}
export function SearchBox({ value = '', setValue, onClick = undefined }: ISearchbox) {
    return (
        <div className="relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 right-10 flex items-center pointer-events-none">
                <span className="feather feather-search text-gray-500 text-lg" />
            </div>
            <input
                type="text"
                name="keyword"
                id="keyword"
                className={classNames(
                    'focus:ring-primary-light focus:border-primary-light rounded-md',
                    'block w-full py-1 px-2 pr-8',
                    'border-gray-100 text-gray-500 placeholder-gray-300'
                )}
                style={{ minWidth: '100px' }}
                placeholder="Search..."
                value={value}
                onChange={(e) => setValue && setValue(e.target.value)}
                onClick={() => {
                    focus
                    onClick && onClick.length == 0 && onClick()
                }}
                onKeyDown={(e) => {
                    if (e.key == ' ') {
                        e.preventDefault()
                        setValue && setValue(value + ' ')
                    }
                }}
            />
            <div className="absolute inset-y-0 right-2 mt-1 flex items-center">
                <button
                    type="reset"
                    className="text-primary-light"
                    onClick={() => setValue && setValue('')}
                >
                    <CloseIcon style={{ width: '20px', height: '20px' }}/>
                </button>
            </div>
        </div>
    )
}

export default SearchBox
